const WA_LINK = "https://wa.me/5581995913182?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20com%20meu%20benef%C3%ADcio%20previdenci%C3%A1rio";
const PATTERN_BG = "https://storage.readdy-site.link/project_files/18151d51-7801-4abd-9f16-f614da2e415d/af06a004-2aed-4cb1-9057-9684b271c567_PATTERN-JPG.jpg?v=ee5ffbdeb4acbf089ee1ea55a2a3cd7a";

export default function CTASection() {
  return (
    <section className="w-full relative overflow-hidden py-28 px-6">
      {/* Background Image with overlay */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src={PATTERN_BG}
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div
          className="absolute inset-0"
          style={{ backgroundColor: "rgba(40, 18, 14, 0.87)" }}
        />
      </div>

      {/* Content — centered */}
      <div className="relative z-10 max-w-3xl mx-auto text-center flex flex-col items-center gap-7">
        <p className="font-body text-peach text-xs tracking-[0.35em] uppercase font-medium">
          Estamos prontos para ajudar
        </p>

        <h2 className="font-display text-4xl lg:text-5xl text-white font-semibold leading-tight">
          Precisa de ajuda com{" "}
          <span className="text-peach font-light italic">seu benefício?</span>
        </h2>

        <div className="w-10 h-px bg-peach/50" />

        <p
          className="font-body text-base md:text-lg leading-relaxed max-w-2xl"
          style={{ color: "rgba(255, 255, 255, 0.65)" }}
        >
          Não deixe que a burocracia impeça você de receber o que é seu por direito. Nossa equipe está pronta para analisar seu caso, tirar todas as suas dúvidas e começar a lutar pelo seu benefício previdenciário imediatamente.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 items-center mt-2">
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center gap-3 font-body font-semibold text-sm px-9 py-4 transition-all duration-300 ease-in-out whitespace-nowrap cursor-pointer tracking-wide hover:bg-gray-100"
            style={{
              backgroundColor: "#ffffff",
              color: "rgb(61, 35, 32)",
              borderRadius: "40px",
            }}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-xl" />
            </div>
            Fale com a Dra. Suellen agora
          </a>
        </div>

        {/* Trust signals */}
        <div className="flex flex-wrap items-center justify-center gap-8 mt-4 pt-7 border-t border-white/10">
          {[
            { icon: "ri-shield-check-line", text: "OAB Registrada" },
            { icon: "ri-lock-line", text: "Sigilo garantido" },
            { icon: "ri-time-line", text: "Resposta rápida" },
          ].map((signal) => (
            <div key={signal.text} className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${signal.icon} text-peach/80 text-base`} />
              </div>
              <span className="font-body text-white/50 text-xs tracking-wide">
                {signal.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
